import React, { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { WindowContext } from '../../Service/Context/WindowContext';
import { fetchDocumentById } from '../../Service/restapi/documentService';
import { InputField } from '../../Atoms/InputFields';

export default function ({ onClick, item, selected, disabled }) {
  const { windowWidth } = useContext(WindowContext);
  const [documentSum, setDocumentSum] = useState(undefined);
  const [documentLastModified, setDocumentLastModified] = useState(undefined);

  useEffect(() => {
    if (item.entityId && item.entityType === 'documents') {
      fetchDocumentById(item.entityId).then((resp) => {
        resp.json().then((document) => {
          if (document.summable) {
            setDocumentSum(document.sum);
          }
          setDocumentLastModified(document.lastModified);
        });
      });
    }
  }, [item]);

  const styles = {
    container: {
      marginBottom: 5,
    },
    item: {
      padding: 5,
      display: 'flex',
      justifyContent: 'space-between',
    },
    checkAndFileName: {
      display: 'flex',
      flex: 2,
    },
    fileName: {
      width: windowWidth > 800 ? '100%' : windowWidth > 400 ? 250 : 100,
    },
    checkIcon: {
      color: '#8ca3b5',
      marginRight: 10,
      alignSelf: 'center',
    },
    lastModified: {
      fontSize: 12,
      fontStyle: 'italic',
      flex: 1,
      textAlign: 'right',
    },
    sum: {
      fontSize: 12,
      flex: 1,
      marginLeft: 5,
    },
    listContainer: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  };

  return (
    <div style={styles.container} className={disabled ? '' : 'clickable'}>
      <InputField
        disabled={disabled}
        toggle={() => onClick(item)}
        checked={selected}
        text={
          <div style={styles.listContainer}>
            <div style={styles.checkAndFileName} className="overflow-ellipsis">
              <div style={styles.fileName}>{item.fileName}</div>
            </div>
            {documentSum !== undefined ? <div style={styles.sum}>{documentSum} €</div> : null}
            <div style={styles.lastModified}>
              {documentLastModified && <Moment fromNow>{documentLastModified}</Moment>}
            </div>
          </div>
        }
      />
    </div>
  );
}
